















































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import VisitorApi from '@/api/visitor'
import { accessKey } from '@/api/visitor'
import Upload from '@/components/Upload/index.vue'
import { getList, getMap, getOrderNum } from '@/utils/order'
import { updateViewer } from '@/utils/util'
import cloneDeep from 'lodash/cloneDeep'
let viewer: any = ''
const blocks: any = [
	{
		title: '基本资料',
		key: 'baseMediaInfoList',
		list: [
			{ picName: '案件传票', type: '610001' }, // 必传
			{ picName: '案件诉状', type: '610002' },
			{ picName: '保单抄件', type: '610003' }, // 必传
			{ picName: '交通事故认定书', type: '610004' },
			{ picName: '标的车资料', type: '610005' }, // 必传
			{ picName: '营运资料', type: '610006' }, // 为营运车必传
			{ picName: '车物资料', type: '610007' },
			{ picName: '其他资料', type: '610008' },
		],
	},
	{
		title: '涉及伤者资料',
		key: 'injuredMediaInfoList',
		list: [
			{ picName: '医疗费单据', type: '620001' },
			{ picName: '用药清单', type: '620002' },
			{ picName: '门诊病历', type: '620003' },
			{ picName: '出院小结', type: '620004' },
			{ picName: '诊断证明书', type: '620005' },
			{ picName: '检查报告单', type: '620006' },
			{ picName: '伤残鉴定报告', type: '620007' },
			{ picName: '被抚养人证明', type: '620008' },
			{ picName: '法医鉴定报告', type: '620009' },
			{ picName: '误工费的证据', type: '620010' },
			{ picName: '护理费的证据', type: '620011' },
			{ picName: '交通费证据', type: '620012' },
			{ picName: '其他证据', type: '620013' },
		],
	},
	{
		title: '涉及死亡资料',
		key: 'deathMediaInfoList',
		list: [
			{ picName: '死亡证明书', type: '630001' },
			{ picName: '尸体解剖检查报告', type: '630002' },
			{ picName: '火化证', type: '630003' },
			{ picName: '户籍注销证明', type: '630004' },
			{ picName: '其他证明', type: '630005' },
		],
	},
]

@Component({
	name: 'UploadData',
	components: {
		Upload,
	},
})
export default class UploadData extends Vue {
	@Prop()
	private mediaInfo!: any // 对已有的数据做展示

	@Prop()
	private isReadonly!: any // 是否仅查看

	@Prop()
	private carProperty!: any // 标的车属性

	@Prop()
	private includeFormType!: any // 涉及保单类型

	@Prop()
	private death!: any // 是否涉及死亡

	private imageLimit: number = 50
	private uploading: boolean = false

	private fileMap: any = {}

	private validate() {
		return new Promise((resolve: any, reject: any) => {
			const basic = this.fileMap['baseMediaInfoList'] || {}
			const arr = [
				{ type: '610001', message: '请上传案件传票' },
				{ type: '610003', message: '请上传保单抄件' },
				{ type: '610005', message: '请上传标的车资料' },
			]
			if (this.carProperty === '01') {
				arr.push({ message: '请上传营运资料', type: '610006' })
			}
			for (const item of arr) {
				if (!basic[item.type] || !basic[item.type].length) {
					this.$message.error(item.message)
					reject(item.message)
					return
				}
			}
			resolve()
		})
	}

	private getList() {
		const res: any = {}
		for (const item in this.fileMap) {
			res[item] = getList(this.fileMap[item])
		}
		return res
	}

	private get blockList() {
		let list = cloneDeep(blocks)
		if (this.carProperty !== '01') {
			// 普通车辆
			list[0].list = list[0].list.filter(
				(item: any) => item.picName !== '营运资料'
			)
		}

		if (this.death !== '1') {
			// 不涉及死亡
			list = list.filter((item: any) => item.title !== '涉及死亡资料')
		}
		if (!['01', '03'].includes(this.includeFormType)) {
			// 不涉及人伤
			list = list.filter((item: any) => item.title !== '涉及伤者资料')
		}
		return list
	}

	private updateViewer() {
		this.$nextTick(() => {
			viewer = updateViewer(viewer, '.upload-data')
		})
	}

	private async addPic(obj: any, key: any) {
		if (this.uploading) {
			return
		}
		try {
			const fileList = await (this.$refs.upload as any).get()
			const hide: any = this.$message.loading('上传中...', 0)
			let currentNum =
				(this.fileMap[key] &&
					this.fileMap[key][obj.type] &&
					this.fileMap[key][obj.type].length) ||
				0
			this.uploading = true
			try {
				if (fileList.length + currentNum > this.imageLimit) {
					this.$message.error(`最多上传${this.imageLimit}张`)
					throw `最多上传${this.imageLimit}张`
				}
				for (const file of fileList) {
					await this.uploadImage(file, obj, key)
				}
				this.$message.success('上传成功')
				this.$emit('change', this.getList())
				this.$nextTick(() => {
					this.updateViewer()
				})
			} finally {
				hide()
				this.uploading = false
			}
		} catch (err) {
			console.log('upload error: ', err)
		}
	}

	private async reupload(img: any, obj: any, key: any) {
		if (this.uploading) {
			return
		}
		const file = await (this.$refs.upload as any).getSingle()
		const hide: any = this.$message.loading('上传中...', 0)
		this.uploading = true
		try {
			await this.uploadImage(
				file,
				{
					...img,
					picId: img.picId,
				},
				key
			)
			this.$message.success('上传成功')
			this.$emit('change', this.getList())
			this.$nextTick(() => {
				this.updateViewer()
			})
		} finally {
			hide()
			this.uploading = false
		}
	}

	private handleRemove(img: any, type: any, key: any) {
		this.$confirm({
			title: '提示',
			content: '确认删除吗 ?',
			onOk: () => {
				this.fileMap[key][type] = this.fileMap[key][type].filter(
					(item: any) => item.picId !== img.picId
				)
				this.fileMap = { ...this.fileMap }
				this.$emit('change', this.getList())
				this.$nextTick(() => {
					this.updateViewer()
				})
			},
		})
	}

	@Watch('mediaInfo', { immediate: true })
	private onMeiaChange() {
		if (this.mediaInfo) {
			for (const item in this.mediaInfo) {
				this.$set(this.fileMap, item, getMap(this.mediaInfo[item]))
			}
			console.log(this.fileMap)
			this.$nextTick(() => {
				this.updateViewer()
			})
		}
	}

	private deactivated() {
		viewer && viewer.destroy()
		viewer = ''
	}

	private beforeDestroy() {
		viewer && viewer.destroy()
		viewer = ''
	}

	public uploadImage(e: any, img: any, key: any) {
		img = { ...img }
		const formData = new FormData()
		formData.append('filecontent', e)
		return VisitorApi.operateAndUpload({
			formData,
			params: {
				cmd: 'imageMogr2/thumbnail/800x800',
			},
		}).then((res: any) => {
			if (!this.fileMap[key]) {
				this.fileMap[key] = {}
			}
			if (!this.fileMap[key][img.type]) {
				this.fileMap[key][img.type] = []
			}

			if (img.picId) {
				const findIndex = this.fileMap[key][img.type].findIndex(
					(item: any) => item.picId === img.picId
				)
				img = Object.assign(img, {
					picId: res.data.picId,
					picUrl: res.data.accessUrl,
				})
				this.fileMap[key][img.type][findIndex] = img
			} else {
				img = Object.assign(img, {
					picId: res.data.picId,
					picUrl: res.data.accessUrl,
					orderNum: getOrderNum(this.fileMap[key], img.type),
				})
				this.fileMap[key][img.type].push(img)
			}

			this.fileMap = { ...this.fileMap }
			console.log(this.fileMap)
		})
	}

	private handlePreview(img: any, e: any) {
		// e.target为svg,svg->i->img-actions->img-wrapper
		let target = e.target.parentNode.parentNode.parentNode
		if (e.target.nodeName === 'path') {
			target = target.parentNode
		}
		const dom: any = target.querySelector('img')
		if (dom) {
			dom.click()
		}
	}
}
